import React from 'react';
import {images} from '../lib/config';

class Headers1 extends React.Component {
  render() {
    return (
      <header id="header">
          <div id="head" className="col-md-12 inline-it">
            <div className="col-md-4 center">
              <img src={images.np} alt="logo" style={{height:'100px',width:'100px'}} className="img-responsive"/>
            </div>
            <div className="header col-md-4">
              <h4><b>नेपाल सरकार</b></h4>
              {/*<h3><b>जल तथा मौसम विज्ञान विभाग</b></h3>*/}
            </div>
            <div className="col-md-4 center">
              <img src={images.nepal_flag} style={{height:'100px'}} className="img-responsive pull-right" alt="not found"/>
            </div>
          </div>
      </header>
    );
  }
}

export default Headers1;











// WEBPACK FOOTER //
// ./src/component/common/Header.js